import { render, staticRenderFns } from "./TorricelliLawViz.vue?vue&type=template&id=42c8cd38&scoped=true"
import script from "./TorricelliLawViz.vue?vue&type=script&lang=js"
export * from "./TorricelliLawViz.vue?vue&type=script&lang=js"
import style0 from "./TorricelliLawViz.vue?vue&type=style&index=0&id=42c8cd38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8cd38",
  null
  
)

export default component.exports